import { memo } from 'react';

// material-ui
import { Typography } from '@mui/material';
// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import useAuth from 'hooks/useAuth';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { user } = useAuth();
    
    const navItems = menuItem.items.filter(item => (item.systemAdminOnly !== true || (user && user.isSystemAdmin === true)) && 
                                                   (item.developerOnly != true || (user && user.isDeveloper === true))).map((item) => {
                                                    
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    // const handleGetAwsData = () => {
    //     GeneralSystemApi.getAwsData();
    // };
    return (
        <>
            {navItems}
          {/* {user && user.isAdmin && <Box sx={{ mb: 2 }}>
                <Button sx={{ ml: 2 }} startIcon={<CloudDownloadOutlined />} onClick={handleGetAwsData}>
                    Get Aws Data
                </Button>
            </Box> } */}
        </>
    );
};

export default memo(MenuList);
